<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="物联网IMEI卡号" v-model="imei" clearable></el-input>
      </el-col>
    
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="device_id" label="设备编号" width="160">
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" width="180"> </el-table-column>
      <el-table-column prop="dateTime" label="日期时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.dateTime.replace('T', ' ') }}
        </template>
      </el-table-column>
      <el-table-column prop="vehicleStartStatus" label="车辆启动关闭状态">
        <template slot-scope="scope">
          {{ scope.row.vehicleStartStatus === 1 ? '启动' : '关闭' }}
        </template>
      </el-table-column>
      <el-table-column prop="gsmSignal" label="GSM信号强度"> </el-table-column>
      <el-table-column prop="gpsSignal" label="GPS卫星数量"> </el-table-column>
      <el-table-column prop="gsmSignalDbm" label="GSM信号数值"> </el-table-column>
      <el-table-column prop="ecuBatteryLevel" label="ECU电池容量">
        <template slot-scope="scope">
          {{ scope.row.ecuBatteryLevel }}%
        </template>
      </el-table-column>
      <el-table-column prop="ecuGpsStatus" label="ECU GPS模组是否正常">
        <template slot-scope="scope">
          {{ scope.row.ecuGpsStatus === 1 ? '正常' : '异常' }}
        </template>
      </el-table-column>
      <el-table-column prop="chargingStatus" label="充电状态">
        <template slot-scope="scope">
          {{ scope.row.chargingStatus === 1 ? '充电中' : '未充电' }}
        </template>
      </el-table-column>
      <el-table-column prop="uploadStatus" label="上传状态">
        <template slot-scope="scope">
          {{ scope.row.uploadStatus === 1 ? '成功' : '失败' }}
        </template>
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      imsi: "",
      data: [],
      linkList: [
        { label: "查看历史数据", path: "/equipment/internationalGPS/equi/lishi/" },
        { label: "上传车辆状态", path: "/equipment/internationalGPS/equi/zhuangtai/" },
        { label: "上传设备登陆信息", path: "/equipment/internationalGPS/equi/longin/" },
        { label: "上传配置参数信息", path: "/equipment/internationalGPS/equi/peizhi/" },
        { label: "上传设备日志", path: "/equipment/internationalGPS/equi/rizhi/" },
        { label: "下发设备指令", path: "/equipment/internationalGPS/equi/downEqIns/" },
        { label: "下发配置指令", path: "/equipment/internationalGPS/equi/downCfgIns/" },
        { label: "OTA升级", path: "/equipment/internationalGPS/equi/ota/" },
      ],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0
        
      },
    };
  },
  watch: {
    deviceId: {
      handler(newVal, oldVal) {
        if (newVal === '') {
          this.pagin.pageNum = 1;
          this.getList();
        }
      },
      deep: true,
    },
    imei: {
      handler(newVal, oldVal) {
        if (newVal === '') {
          this.pagin.pageNum = 1;
          this.getList();
        }
      },
      deep: true,
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.deviceId = this.$route.params.id !== ':id' ? this.$route.params.id : '';
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        topicType: "C/STATUS",
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      if (this.imsi.trim() != "") {
        params.imsi = this.imsi;
      }
      this.$http
        .post(`${this.env}/manage/carDeviceTopicUpload/list`, params)
        .then((results) => {
          console.log(results);
          const records = results["data"]["data"]["records"];
          // 解析 json_data 字段
          this.data = records.map(item => {
            let jsonData = {};
            try {
              jsonData = JSON.parse(item.json_data || '{}');
            } catch (e) {
              console.error('解析 json_data 失败:', e);
            }
            return {
              ...item,
              dateTime: jsonData.dateTime || '',
              vehicleStartStatus: jsonData.vehicleStartStatus,
              gsmSignal: jsonData.gsmSignal,
              gpsSignal: jsonData.gpsSignal,
              gsmSignalDbm: jsonData.gsmSignalDbm,
              ecuBatteryLevel: jsonData.ecuBatteryLevel,
              ecuGpsStatus: jsonData.ecuGpsStatus,
              chargingStatus: jsonData.chargingStatus,
              uploadStatus: jsonData.uploadStatus,
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },

  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>